<template>
  <editor :id="id" default-tab="content_list" :tabs="tabs"></editor>
</template>

<script>
import Editor from '@/components/Editor'
import Basic from './list/Editor'

export default {
  props: ['id'],
  components: {
    Editor
  },
  data () {
    return {
      tabs: [
        {title: "Content List", name: "content_list", component: Basic},
      ]
    }
  }
}
</script>
